module.exports = __webpack_public_path__ + "static/media/1-7.2efabd05.mp3";